// Moved from `src/hooks/query/useQueryJoinedTeams.ts` (now a shim) with OT3
// slice 2 (ARCFE-955). Token-seam severance; the bare catch-swallow (returns
// undefined on any failure) is frozen behaviour — preserved, not improved.
import { useQuery } from '@tanstack/react-query';

import { GET_JOINED_TEAMS } from '../../contracts/keys';
import { getJoinedTeams } from '../api/teams';
import { getWorkspaceDataConfig } from '../config';

export { GET_JOINED_TEAMS };

export function useQueryJoinedTeams() {
  const token = getWorkspaceDataConfig().useAuthToken();

  return useQuery({
    queryKey: [GET_JOINED_TEAMS],
    retry: 3,
    enabled: !!token,
    queryFn: async () => {
      try {
        const { data } = await getJoinedTeams();
        return data;
        // eslint-disable-next-line no-empty -- frozen behaviour: the legacy hook swallowed every error
      } catch {}
    },
  });
}
